module.exports = __webpack_public_path__ + "img/undraw_partying_re_at7f.13997473.svg";